import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PublicWebService {
  APIURL = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getVideojetCountries(): Observable<any> {
    return this.http.get<any>(`${this.APIURL}public-web/getVideojetCountries`);
  }

  getVideojetDistributors(countryName: string): Observable<any> {
    return this.http.get<any>(`${this.APIURL}public-web/getCountryDataByName?CountryName=${countryName}`);
  }
  

  getVideojetOffices(countryName: string): Observable<any> {
    return this.http.get<any>(`${this.APIURL}public-web/getVJOfficesCountryDataByName?CountryName=${countryName}`);
  }
}
